import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, Tip } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran15() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "15");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 15" title="War Game">
        <YouTubeEmbed videoId="gvAR0fYcANY" title="War Game — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/15-war-game.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="F minor — i and ♭VII only">
        {/* Jason's annotation: i, ♭VII  |  chart: Fm | Eb | Eb | Fm  |  Eb is native to F natural minor — not borrowed */}
        <RomanNumeralAnalysis
          label="Entire chart"
          caption="Fm → E♭ → E♭ → Fm, one bar each. These are the only two chords on Jason's chart."
          chords={[
            { chord: "Fm", rn: "i",    function: "Tonic", pitches: ["F3","Ab3","C4","F4"] },
            { bar: true },
            { chord: "Eb", rn: "♭VII",                    pitches: ["Eb3","G3","Bb3","Eb4"] },
            { bar: true },
            { chord: "Eb", rn: "♭VII",                    pitches: ["Eb3","G3","Bb3","Eb4"] },
            { bar: true },
            { chord: "Fm", rn: "i",    function: "Tonic", pitches: ["F3","Ab3","C4","F4"] },
          ]}
        />
        <KeyIdea title="♭VII is native to natural minor">
          E♭ is the ♭VII of F minor. This is not borrowing — it lives in the F natural minor scale (F G A♭ B♭ C D♭ E♭). There is no V chord (C major) on the chart, so nothing pulls hard toward Fm: the music just rocks between i and ♭VII.
        </KeyIdea>
      </Section>
      <Section eyebrow="Takeaway" title="Two chords and a rhythm">
        <Tip title="Try it yourself">
          Play Fm for one bar, E♭ for two, Fm for one, and loop it. Jason's chart gives the rhythm: strike on beat 1, then on the "and" of 3, held through beat 4. Sing anything over the loop — words, a melody, scat syllables.
        </Tip>
      </Section>
    </LessonShell>
  );
}
